/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { GetItemCommandOutput, PutItemCommandOutput, ScanCommandOutput } from '@aws-sdk/client-dynamodb';

export const createMockClientPutResponse = (
  partialRecord: Partial<PutItemCommandOutput> = {},
): PutItemCommandOutput => {
  return {
    $metadata: {},
    Attributes: {},
    ...partialRecord,
  };
};

export const createMockClientScanResponse = (partialRecord: Partial<ScanCommandOutput> = {}): ScanCommandOutput => {
  return {
    $metadata: {},
    Items: [],
    LastEvaluatedKey: undefined,
    ...partialRecord,
  };
};

export const createMockClientGetResponse = (
  partialRecord: Partial<GetItemCommandOutput> = {},
): GetItemCommandOutput => {
  return {
    $metadata: {},
    ...partialRecord,
  };
};
